import { useState } from 'react';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';
import { MultiSelectChips } from '@/components/shared/multi-select-chips';
import { useBootstrapData } from '@/data/user/bootstrap-data';
import type { KnowledgeArea } from '@/models/bootstrap/taxonomy';

interface KnowledgeAreasEditDialogProps {
  currentValues: KnowledgeArea[];
  onClose: () => void;
  onSave: (knowledgeAreas: KnowledgeArea[]) => void;
}

export const KnowledgeAreasEditDialog = ({
  currentValues,
  onClose,
  onSave,
}: KnowledgeAreasEditDialogProps) => {
  const { bootstrap } = useBootstrapData();
  const knowledgeAreas = bootstrap?.taxonomy?.knowledge_areas ?? [];
  const [selectedKnowledgeAreas, setSelectedKnowledgeAreas] =
    useState<KnowledgeArea[]>(currentValues);

  const handleToggleKnowledgeArea = (knowledgeArea: KnowledgeArea) => {
    const isSelected = selectedKnowledgeAreas.some(
      (currentKnowledgeArea) => currentKnowledgeArea.id === knowledgeArea.id
    );
    if (isSelected) {
      setSelectedKnowledgeAreas(
        selectedKnowledgeAreas.filter(
          (currentKnowledgeArea) => currentKnowledgeArea.id !== knowledgeArea.id
        )
      );
    } else {
      setSelectedKnowledgeAreas([...selectedKnowledgeAreas, knowledgeArea]);
    }
  };

  const handleSave = () => {
    onSave(selectedKnowledgeAreas);
  };

  const options = knowledgeAreas.map((knowledgeArea) => {
    return {
      label: knowledgeArea.description_pt_br,
      value: knowledgeArea,
    };
  });

  return (
    <ConfirmDialog
      actionLabels={{
        cancel: 'Cancelar',
        confirm: 'Salvar',
      }}
      onClose={onClose}
      open
      onConfirm={handleSave}
      title="Temas"
    >
      <MultiSelectChips
        options={options}
        currentValues={selectedKnowledgeAreas}
        onToggle={handleToggleKnowledgeArea}
        getValueKey={(selectedKnowledgeArea) => selectedKnowledgeArea.id}
        direction="row"
        shouldAnimate={false}
      />
    </ConfirmDialog>
  );
};
